const routes = [
    {
        path: "/banks",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'bank_index'
        }
    }
];

export default routes;
